import React from 'react';

import { HeaderEmbeddables } from 'modules/HeaderEmbeddables';

import { Footer, HeaderTags } from '../../components';
import { Container } from './styles';

export type PropTypes = {
  children?: React.ReactNode;
  title?: string;
  description?: string | null;
};

const LandingPageLayout = ({ children = null, title, description }: PropTypes): JSX.Element => (
  <>
    <HeaderTags title={title} description={description || ''} />
    <HeaderEmbeddables />
    <Container>{children}</Container>
    <Footer />
  </>
);

export default LandingPageLayout;
